import axios from 'axios'
const uri = 'descargar-xframe/php/'

const get = (url) => {
	return axios.get(uri + url)
}

const post = (url, datos) => {
	return axios.post(uri + url, datos)
}

export default {
	getBuzones () {
		return get('listado-buzones.php')
	},
	buscar (filtro) {
		const datos = _.clone(filtro)
		datos.fecha = (!filtro.fecha) ? null : filtro.fecha.toLocaleDateString()
		return post('buscar.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/descargar-xframe/vue/api.js